import Vue from 'vue';
import { has } from 'lodash';

function afterEachRoutes(router) {
  router.afterEach((to) => {
    Vue.nextTick(() => {
      document.title = has(to.meta, 'title') ? `${to.meta.title} - Classting AI` : 'Classting AI';
    });
  });
}

export default afterEachRoutes;



// WEBPACK FOOTER //
// ./src/router/afterEachRoutes.js